// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"511":"2994ab36","834":"e2d64bed"}[chunkId] + ".chunk.css";
};